import { render, staticRenderFns } from "./DepositCommission.vue?vue&type=template&id=20c720f2&scoped=true"
import script from "./DepositCommission.vue?vue&type=script&lang=js"
export * from "./DepositCommission.vue?vue&type=script&lang=js"
import style0 from "./DepositCommission.vue?vue&type=style&index=0&id=20c720f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c720f2",
  null
  
)

export default component.exports